"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShapeElement_1 = require("./ShapeElement");
var Fill_1 = require("./Fill");
var Group_1 = require("./Group");
exports.constructShapeElementFromRawData = function (rawShapeElementData, version) {
    switch (rawShapeElementData.ty) {
        case ShapeElement_1.ShapeElementType.Fill:
            return new Fill_1.Fill(rawShapeElementData, version);
        case ShapeElement_1.ShapeElementType.Group:
            return new Group_1.Group(rawShapeElementData, version);
        default:
            return new ShapeElement_1.ShapeElement(rawShapeElementData, version);
    }
};
//# sourceMappingURL=ShapeElementFactory.js.map